import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=1544f21a&scoped=true"
import script from "./tabList.vue?vue&type=script&lang=js"
export * from "./tabList.vue?vue&type=script&lang=js"
import style0 from "./tabList.vue?vue&type=style&index=0&id=1544f21a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544f21a",
  null
  
)

export default component.exports